import { memo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { dateToString } from '@/utils';
import { useGetChildActivitiesQuery } from '@/services/child-api';
import { PlusSvg } from '@/assets/icons';
import Table from '@/components/table';
import Button from '@/components/button';
import AddModal from './add-modal';

const Activity = ({ childId, permissions }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching, refetch } = useGetChildActivitiesQuery({ childId, pageNumber });
  console.log(data);

  const [isAddModalOpen, openAddModal] = useState(false);

  const columns = [
    {
      title: 'Activity',
      dataIndex: 'type',
      render: (value, record) => (
        <>
          {value.name}
          {record.statusReason && record.statusReason.name && (
            <div>
              <i>
                <strong>Reason:</strong> {record.statusReason.name}
              </i>
            </div>
          )}
        </>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'activity',
      width: 300,
      render: (value) => {
        const startDateString = dateToString(value.start);

        if (value.end) {
          const endDateString = dateToString(value.end);

          const start = new Date(value.start);
          const end = new Date(value.end);
          const differenceInTime = end.getTime() - start.getTime();
          const differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24)) + 1;

          return (
            <>
              {`${startDateString} to ${endDateString} `}
              <i>
                ({differenceInDays} day{differenceInDays > 1 ? 's' : ''})
              </i>
            </>
          );
        }

        return startDateString;
      },
    },
    {
      title: 'Note',
      dataIndex: 'note',
      ellipsis: true,
    },
    {
      title: 'User',
      dataIndex: 'createUser',
      ellipsis: true,
    },
    permissions.writeChild && {
      title: (
        <Button type="primary" icon={<PlusSvg fontSize="12" />} onClick={() => openAddModal(true)}>
          Add
        </Button>
      ),
      key: 'action',
      align: 'right',
      width: 100,
    },
  ].filter((item) => item);

  return (
    <>
      <Table
        columns={columns}
        dataSource={data?.data}
        rowKey="childActivityId"
        loading={isFetching}
        pageInfo={data}
        size="small"
      />
      <AddModal childId={childId} open={isAddModalOpen} refetch={refetch} onClose={() => openAddModal(false)} />
    </>
  );
};

export default memo(Activity);
